__turbopack_context__.v({
  "container": "Hy-dsq_container",
  "lastBreadcrumb": "Hy-dsq_lastBreadcrumb",
  "layout-body": "Hy-dsq_layout-body",
  "layout-body-card": "Hy-dsq_layout-body-card",
  "layoutBreadcrumb": "Hy-dsq_layoutBreadcrumb",
  "nameBreadcrumb": "Hy-dsq_nameBreadcrumb",
  "page-body-wrap": "Hy-dsq_page-body-wrap",
  "paragraph-content": "Hy-dsq_paragraph-content",
  "title": "Hy-dsq_title",
  "white-layout-body": "Hy-dsq_white-layout-body",
  "white-layout-body-card": "Hy-dsq_white-layout-body-card",
  "wrap-container": "Hy-dsq_wrap-container",
  "wrap-content": "Hy-dsq_wrap-content",
});
